const header = {

	elem: {
		header: document.querySelector('.c26-header'),
		newsletterModal: document.querySelector('.c26-newsletter'),
		newsletterButton: document.querySelector('.c26-header .newsletter'),
		toggle: document.querySelector('.c26-header__menu-toggle')
	},
	
	mql: {
		large: window.matchMedia('(min-width: 768px)')
	},

	newsletterClose() {
		header.elem.newsletterModal.close();
	},
	
	newsletterOpen(e) {
		e.preventDefault();
		header.elem.newsletterModal.showModal();
		header.elem.newsletterModal.querySelector('.c26-newsletter__close').addEventListener('click', header.newsletterClose);		
	},

	reset() {
		if(header.mql.large.matches) {
			header.elem.header.classList.remove('open');
			header.elem.toggle.setAttribute('aria-expanded', false);
			header.elem.toggle.setAttribute('aria-label', 'Open Menu');
			header.elem.toggle.setAttribute('aria-pressed', false);
		}
	},

	replace(txt) {
		return (txt === 'Open Menu') ? txt.replace('Open', 'Close') : txt.replace('Close', 'Open');
	},
	
	reverse(txt) {
		return (txt === 'false') ? 'true' : 'false';		
	},

	toggle(e) {
		e.preventDefault();
		header.elem.header.classList.toggle('open');
		header.elem.toggle.setAttribute('aria-expanded', header.reverse(header.elem.toggle.getAttribute('aria-expanded')));
		header.elem.toggle.setAttribute('aria-label', header.replace(header.elem.toggle.getAttribute('aria-label')));
		header.elem.toggle.setAttribute('aria-pressed', header.reverse(header.elem.toggle.getAttribute('aria-pressed')));

	},
	
	init() {
		header.elem.newsletterButton.addEventListener('click', header.newsletterOpen);
		header.elem.toggle.addEventListener('click', header.toggle);
		window.addEventListener('resize', header.reset);
	}

};

export { header };




